import { sendLog } from '@/log';
import { globalLog } from '@/log/pages/common';
import { throttle } from 'lodash';

export const mouseMoveFn = throttle(
  (e) => {
    sendLog(globalLog.mouseMove, { x: e?.clientX, y: e?.clientY });
  },
  60000,
  {
    leading: true,
    trailing: false
  }
);
